import React, { Component } from "react";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";
import { DragModal, TTPModal } from "../Common/Modal/TTPModal";
import styles from "./ClientsVue.local.scss";
import { Button, Select } from "antd";
import { connect } from "react-redux";
import {
  setImportClientsBudgetModal,
  setImportBudgetAttachment,
  setImportedBudgetYear
} from "Actions";
import _ from "i18n";
import { YEARS_VALUES } from "Config";
import DocumentUploader from "../Common/DocumentUploader/DocumentUploader";
import { ICONS, SvgIcon } from "../Common/Icons";
import { importClientsBudget, fetchClientsList } from "Thunks";
import { onSuccess, onError } from "Utils";

const { Option } = Select;

class ImportClientsBudgetModal extends Component {
  handleCancelImportBudget = () => {
    const { dispatch } = this.props;
    dispatch(setImportClientsBudgetModal(false));
  };

  handleDrop = acceptedFiles => {
    if (acceptedFiles.length === 0) return;
    this.props.dispatch(setImportBudgetAttachment(acceptedFiles[0]));
  };

  handleYearChange = year => {
    this.props.dispatch(setImportedBudgetYear(year));
  };
  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170070:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );
      case 170031:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("fileSize")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  handleImportClientsBudget = () => {
    this.props.dispatch(importClientsBudget()).then(
      res => {
        onSuccess(res, {
          title: _("importSuccess"),
          body: _("imported successfully")
        });
        this.props.dispatch(fetchClientsList());
        this.props.dispatch(setImportClientsBudgetModal(false));
        this.props.dispatch(setImportBudgetAttachment(null));
      },
      error => {
        onError(this.renderErrorText(error.response.data.errors[0].code));
      }
    );
  };

  render() {
    const { attachment, importedYear } = this.props;
    return (
      <TTPModal
        mask={true}
        visible={this.props.isImportModalVisible}
        footer={null}
        width={650}
      >
        {this.props.isImportModalVisible ? (
          <div className="tamtam-modal upload-modal upload-modal__body">
            <ModalCloseButton onClose={this.handleCancelImportBudget} />
            <div className="upload-modal__content">
              <DragModal>
                <div className="upload-modal__header small-12">
                  <div className="upload-modal__header-icon">
                    <SvgIcon icon={ICONS.UPLOAD} />
                  </div>
                  <div
                    className="upload-modal__header-title"
                    style={{ display: "inline-block", marginRight: "auto" }}
                  >
                    {_("importer budget clients")} {this.props.year}
                  </div>
                </div>
              </DragModal>
              <div className={styles.content_modal}>
                <div className={"row"}>
                  <div className={`columns medium-12 ${styles.select_label}`}>
                    selectionné l'année :
                  </div>{" "}
                  <div className={`columns medium-12 ${styles.select_span}`}>
                    <Select
                      defaultValue={importedYear.toString()}
                      style={{ width: 300 }}
                      onChange={this.handleYearChange}
                    >
                      {YEARS_VALUES.map((year, i) => {
                        return (
                          <Option value={year} key={i}>
                            {year}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className={`columns medium-12`}>
                    <div className={styles.model_description}>
                      {_("importer budget clients : ")} {importedYear}
                    </div>
                  </div>
                  <span className={"columns medium-12"}>
                    <DocumentUploader
                      attachment={attachment}
                      handleDrop={this.handleDrop}
                      acceptedFiles=".xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                  </span>
                  <div className={styles.modal_footer}>
                    <Button
                      type={"success"}
                      className={styles.import_btn}
                      // disabled={this.state.disabledSave}
                      disabled={!this.props.attachment}
                      loading={this.props.importFetching}
                      onClick={this.handleImportClientsBudget}
                    >
                      {_("import")}
                    </Button>

                    <Button
                      type={"success"}
                      className={styles.cancel_btn}
                      onClick={this.handleCancelImportBudget}
                    >
                      {_("cancel")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </TTPModal>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  isImportModalVisible: state.clients.importClientsBudget.isImportModalVisible,
  attachment: state.clients.importClientsBudget.importAttachment,
  importFetching: state.clients.importClientsBudget.fetching,
  importedYear: state.clients.importClientsBudget.importedYear
});

export default connect(mapStateToProps)(ImportClientsBudgetModal);



// WEBPACK FOOTER //
// ./src/components/ClientsList/ImportClientsBudgetModal.js